import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const AccountOutline = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M15 11c3.38 1.59 6.167 4.89 6.167 7.263 0 2.098-1.61 2.68-2.543 2.977-3.359 1.07-10.69.954-14.081 0C3.6 20.977 2 20.35 2 18.264 2 15.89 4.63 12.59 8 11"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Path
      d="M11.589 12.298a5.15 5.15 0 1 0 0-10.298 5.15 5.15 0 0 0 0 10.298Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <Path
      d="M12.021 15a.296.296 0 1 1-.592 0 .296.296 0 0 1 .592 0Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth={1.407}
    />
  </Icon>
);

export default AccountOutline;
